import { useState } from 'react';
import { saveEditedSubmissionData, getPowerappRawDataForEditing } from '../../../../../../api';

export const useEditSubmissionData = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentPowerapp, setCurrentPowerapp] = useState(null);
    const [loading, setLoading] = useState(false);

    const openModal = async (editslug) => {
        // Fetch raw, unredacted data for editing
        try {
            const response = await getPowerappRawDataForEditing({
                slug: editslug,
            });
            
            if (response.status) {
                setCurrentPowerapp(response.data);
                setIsModalOpen(true);
            } else {
                console.error('Failed to fetch raw application data:', response.message);
            }
        } catch (error) {
            console.error('Error fetching raw application data:', error);
        }
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setCurrentPowerapp(null);
    };

    const handleSave = async (editedData) => {
        if (!currentPowerapp) return;

        setLoading(true);
        try {
            const response = await saveEditedSubmissionData(currentPowerapp.editslug, editedData);
            
            // If we get here, the save was successful (no error thrown)
            // Update the current powerapp with the fresh data if available
            if (response?.data?.powerapp) {
                setCurrentPowerapp(response.data.powerapp);
            }
            return response;
        } catch (error) {
            console.error('Error saving submission data:', error);
            // Re-throw the error so the modal can handle it
            throw error;
        } finally {
            setLoading(false);
        }
    };

    return {
        isModalOpen,
        currentPowerapp,
        loading,
        openModal,
        closeModal,
        handleSave
    };
};
